import { Button, Wrapper } from '@american-autonomy/ag-ui';

import { DRAWING_TOOL } from 'components/Map/constants';
import useMapContext from 'components/Map/hooks/useMapContext';

import useTranslation from './hooks/useTranslation';

import { POINT_MODE, TEST_ID } from './constants';
import type { Props } from './types';

import styles from './styles.module.scss';

const MapControlPopup = ({
    className = '',
    onClickAddPoint,
    onClickDismiss,
    testId = TEST_ID
}: Props) => {
    const { mapState } = useMapContext();
    const { drawingTool, pointMode } = mapState;

    const {
        ADD,
        DISMISS,
        RETICLE_ADD_POINT_CIRCLE,
        RETICLE_ADD_POINT_POLYGON,
        TOUCH_ADD_POINT_CIRCLE,
        TOUCH_ADD_POINT_POLYGON
    } = useTranslation();

    const POINT_MODE_TEXT = {
        [POINT_MODE.RETICLE]: {
            [DRAWING_TOOL.CIRCLE]: RETICLE_ADD_POINT_CIRCLE,
            [DRAWING_TOOL.POLYGON]: RETICLE_ADD_POINT_POLYGON
        },
        [POINT_MODE.TOUCH]: {
            [DRAWING_TOOL.CIRCLE]: TOUCH_ADD_POINT_CIRCLE,
            [DRAWING_TOOL.POLYGON]: TOUCH_ADD_POINT_POLYGON
        }
    };

    const BUTTON_TEXT = {
        [POINT_MODE.RETICLE]: {
            onClick: onClickAddPoint,
            text: `⊙ ${ADD}`
        },
        [POINT_MODE.TOUCH]: {
            onClick: onClickDismiss,
            text: DISMISS
        }
    };

    const pointModeText = POINT_MODE_TEXT[pointMode][drawingTool];
    const { onClick, text: buttonText } = BUTTON_TEXT[pointMode];

    return (
        <Wrapper className={`${styles.wrapper} ${className}`} testId={testId}>
            <div className={styles.popup}>
                <div className={styles.text}>{pointModeText}</div>

                <Button className={styles.addButton} onClick={onClick}>
                    {buttonText}
                </Button>
            </div>
        </Wrapper>
    );
};

export default MapControlPopup;
